import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-detailed-product-description',
  templateUrl: './detailed-product-description.component.html',
  styleUrls: ['./detailed-product-description.component.scss'],
})
export class DetailedProductDescriptionComponent {
  @Input() title: string = '';
  @Input() lowRiskContent: string = '';
  @Input() moderateRiskContent?: string;
  @Input() highRiskContent?: string;

  selectedRiskTab: number = 0;

  constructor(public activeModal: NgbActiveModal) {}

  handleSelectedRisk(tabIndex: number) {
    this.selectedRiskTab = tabIndex;
  }

  handleCloseModal() {
    this.activeModal.close();
  }
}
